import { xorWith, isEqual, isEmpty } from "lodash";

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));
